import { Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { useAppMeta } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { DistrictDetailContext } from "contexts/LocationContexts/DistrictDetailContext";
import DistrictBasicDetails from "./districtComponents/DistrictBasicDetails";
import { useGetDistrictDetailQuery } from "store/services/LocationsApi/districtApi";
import DistrictDrtailTabs from "./districtComponents/DistrictDrtailTabs";
// import { EditOutlined } from "@mui/icons-material";

const DistrictDetailScreen = () => {
  const { id } = useParams();
  const breadcrumbs = [
    {
      title: "District",
      path: "/app/crm/district/list",
    },
    { title: "District Detail" },
  ];

  const PageActions = () => (
    <Link to={`/app/crm/district/${id}/edit`} state={{ from: "detail" }}>
      {/* <Button variant="contained" startIcon={<EditOutlined />}>
        Edit
      </Button> */}
    </Link>
  );

  const {
    data: districtDetail,
    isLoading: loadingDistrict,
    error,
  } = useGetDistrictDetailQuery(id);

  useAppMeta("District Detail");

  return (
    <DistrictDetailContext.Provider value={{ districtDetail, loadingDistrict }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingDistrict}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <DistrictBasicDetails />
          <Divider />

          <DistrictDrtailTabs />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </DistrictDetailContext.Provider>
  );
};

export default DistrictDetailScreen;
